import React, { useState } from 'react';
import { Icon } from 'semantic-ui-react';
import { useHistory, useRouteMatch } from 'react-router-dom';
import {
  SubmenuContainer,
  MenuHeader,
  BackButton,
  HeaderTitle,
  MenuContent,
  SubmenuList,
  SubmenuItem,
  SubmenuIcon,
  SubmenuText,
  SubmenuArrow
} from './styles';
import { MenuItemProps, SubMenuItemProps } from '../../containers/types';

interface MobileSubmenuProps {
  category: MenuItemProps;
  currentPage: any;
  onBack: () => void;
  onNavigate: (item: SubMenuItemProps) => void;
}

const MobileSubmenu: React.FC<MobileSubmenuProps> = ({
  category,
  currentPage,
  onBack,
  onNavigate
}) => {
  const [isLeaving, setIsLeaving] = useState(false);
  const [isEntering] = useState(true);

  const handleBack = () => {
    setIsLeaving(true);
    setTimeout(() => {
      onBack();
    }, 280);
  };

  const getSubmenuIcon = (itemName: string): string => {
    // Mapeia nomes de itens para ícones específicos
    const iconMap: Record<string, string> = {
      'fire-insurance-budget': 'file alternate outline',
      'fire-insurance-budgets': 'folder outline',
      'fire-insurance-policies': 'file text outline',
      'fire-insurance-invoices': 'money bill alternate outline',
      'fire-insurance-batches': 'boxes',
      'find-record': 'search',
      'bond-insurance': 'plus circle',
      'bond-insurances': 'list alternate outline',
      'bond-insurance-proposals': 'handshake outline',
      'bond-insurance-policies': 'shield alternate',
      'canceled-bond-insurances': 'times circle outline',
      'expired-bond-insurances': 'clock outline',
      'reports-form': 'chart bar outline',
      'capitalizations': 'lock',
      'claim-estates': 'fire',
      'claim-estate-responsible-transfer': 'users',
      'new-user': 'user plus',
      'list-users': 'users',
      'new-franchise': 'plus',
      'list-franchises': 'handshake',
      'list-master-franchises': 'sitemap',
      'franchises-dashboard': 'chart line',
    };

    return iconMap[itemName] || 'circle outline';
  };

  return (
    <SubmenuContainer isEntering={isEntering && !isLeaving} isLeaving={isLeaving}>
      <MenuHeader>
        <BackButton onClick={handleBack}>
          <Icon name="arrow left" />
        </BackButton>
        <HeaderTitle>{category.text}</HeaderTitle>
        {/* Espaço para manter o título centralizado */}
        <div style={{ width: 44 }} />
      </MenuHeader>

      <MenuContent>
        <SubmenuList>
          {category.submenuItems?.map((item) => {
            const isActive = currentPage?.name === item.name;

            return (
              <SubmenuItem
                key={item.id}
                isActive={isActive}
                onClick={() => onNavigate(item)}
              >
                <SubmenuIcon isActive={isActive}>
                  <Icon name={getSubmenuIcon(item.name) as any} />
                </SubmenuIcon>
                <SubmenuText isActive={isActive}>{item.text}</SubmenuText>
                <SubmenuArrow isActive={isActive}>
                  <Icon name="chevron right" />
                </SubmenuArrow>
              </SubmenuItem>
            );
          })}
        </SubmenuList>
      </MenuContent>
    </SubmenuContainer>
  );
};

export default MobileSubmenu;
